import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { getPrimaryLanguage } from "@krea/customer-features/utils";

// Disable localStorage usage for language detection and rely on cookies instead
// localStorage is not available in some browsers some times and causes crashes.
const languageDetector = new LanguageDetector(null, {
  caches: ["cookie"],
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        customerWeb: require("./translations/customer/en.json"),
        common: require("@krea/customer-features/translations/common/en.json"),
      },
      sv: {
        customerWeb: require("./translations/customer/sv.json"),
        common: require("@krea/customer-features/translations/common/sv.json"),
      },
      fi: {
        customerWeb: require("./translations/customer/fi.json"),
        common: require("@krea/customer-features/translations/common/fi.json"),
      },
    },
    lng: getPrimaryLanguage(),
    fallbackLng: "en",
    supportedLngs: ["sv", "en", "fi"],
    ns: ["customerWeb", "common"],
    defaultNS: "customerWeb",
    fallbackNS: "common",
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "ul", "li", "a"],
    },
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
